import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../misc/Card";
import { AnalyticsTotals } from "../../types/analytics";

interface StatTilesProps {
    totals: AnalyticsTotals;
}

const TILES: { key: keyof AnalyticsTotals; label: string; hint: string }[] = [
    { key: "published", label: "Posts published", hint: "One per network post" },
    { key: "networksUsed", label: "Networks used", hint: "Channels that received a post" },
    { key: "listingsCovered", label: "Listings covered", hint: "Listings with at least one post" },
    { key: "videos", label: "Videos published", hint: "Slideshow and uploaded videos" },
];

const StatTiles: React.FC<StatTilesProps> = ({ totals }) => (
    <div className="grid grid-cols-2 gap-4 min-[900px]:grid-cols-4">
        {TILES.map((tile) => (
            <Card key={tile.key} className="mt-0">
                <CardHeader className="pb-2">
                    <CardTitle className="text-left text-sm font-semibold text-gray-500">
                        {tile.label}
                    </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                    <div className="text-3xl font-bold text-primary">
                        {totals[tile.key].toLocaleString()}
                    </div>
                    <p className="text-xs text-gray-500">{tile.hint}</p>
                </CardContent>
            </Card>
        ))}
    </div>
);

export default StatTiles;
